import axios from 'axios';
import { PixVerificationResponse } from './interfaces';

export const requestTipPixPayment = (payload: any): Promise<any> =>
  axios.post('v1/tips/web/purchases', payload.toJSON());

export const verifyTipPixPayment = (
  purchaseID: string | null,
): Promise<any | PixVerificationResponse> => {
  return axios.get(`v1/tips/purchases/${purchaseID}`);
};
